query Reference4Codes($Ref4CodeFilter: Reference4CodeFilter) {
  reference4Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref4CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
}
